/**
 * Created by shiyonggao on 2019/1/22.
 */

const lodash = require('lodash');
const $ = require('jquery');
const Language = require('../language/lang_config');
const config = require('./config');

/**
 * 对外提供公共方法
 * @type {{getParamers: (function(*=))}}
 */
module.exports = {
    version : 'v6.0.7',

    /***
     * 国家自定义展示
     */
    countryModuleCustomData : {
        narutoen: {
            data : {
                US: {
                    name: "NORTH AMERICA",
                    imgurl: `${config.host_img}/upload/1552706044/US.jpg`
                },
                GB: {
                    name: "EUROPE",
                    imgurl: `${config.host_img}/upload/1552706044/GB.jpg`
                },
                AU: {
                    name: "OCEANIA",
                    imgurl: `${config.host_img}/upload/1552706044/AU.jpg`
                },
                SG: {
                    name: "OTHERS",
                    imgurl: `${config.host_img}/upload/1552706044/SG.jpg`
                }
            },
            country: 'custom1'
        },
        narutoes: {
            data: {
                MX: {
                    name: "México",
                    imgurl: `${config.host_img}/upload/1552709858/mex.png`,
                    sign: `${config.host_img}/upload/1552709858/country/mex.jpg`

                },
                ES: {
                    name: "España",
                    imgurl: `${config.host_img}/upload/1552709858/esp.png`,
                    sign: `${config.host_img}/upload/1552709858/country/esp.jpg`

                },
                AR: {
                    name: "Argentina",
                    imgurl: `${config.host_img}/upload/1552709858/arg.png`,
                    sign: `${config.host_img}/upload/1552709858/country/arg.jpg`
                },

                US: {
                    name: "Otros",
                    imgurl: `${config.host_img}/upload/1552709858/other.png`,
                    sign: `${config.host_img}/upload/1552709858/country/other.png`
                }
            },
            country: 'custom2'
        }

    },


    /**
     * 五位语言key转2位语言key
     */
    lang2 : {
        'zh-CN': 'cn',
        'en-US': 'en',
        'ar-AE': 'ar',
        'el-GR': 'el',
        'es-ES': 'es',
        'fr-FR': 'fr',
        'it-IT': 'it',
        'ja-JP': 'ja',
        'nl-NL': 'nl',
        'pl-PL': 'pl',
        'pt-PT': 'pt',
        'de-DE': 'de',
        'ru-RU': 'ru',
        'sv-SE': 'sv',
        'tr-TR': 'tr',
        'zh-TW': 'tw',
    },

    /**
     * 其他语言key转五位语言key
     */
    lang2key:{
        'zh': 'zh-CN',
        'cn': 'zh-CN',
        'en': 'en-US',
        'us': 'en-US',
        'pt': 'pt-PT',
        'br': 'pt-PT',
        'ja': 'ja-JP',
        'jp': 'ja-JP',
        'ar': 'ar-AE',
        'de': 'de-DE',
        'el': 'el-GR',
        'es': 'es-ES',
        'fr': 'fr-FR',
        'it': 'it-IT',
        'nl': 'nl-NL',
        'pl': 'pl-PL',
        'ru': 'ru-RU',
        'sv': 'sv-SE',
        'tr': 'tr-TR',
        'tw': 'zh-TW',
    },

    /**
     * 其他语言key转五位语言key
     */
    lang5To5key: {
        'zh-cn': 'zh-CN',
        'en-us': 'en-US',
        'pt-pt': 'pt-PT',
        'pt-br': 'pt-PT',
        'ja-jp': 'ja-JP',
        'ar-ae': 'ar-AE',
        'de-de': 'de-DE',
        'el-gr': 'el-GR',
        'es-es': 'es-ES',
        'fr-fr': 'fr-FR',
        'it-it': 'it-IT',
        'nl-nl': 'nl-NL',
        'pl-pl': 'pl-PL',
        'ru-ru': 'ru-RU',
        'sv-se': 'sv-SE',
        'tr-tr': 'tr-TR',
        'zh-tw': 'zh-TW',
    },

    getWebSiteName() {
        return config.website;
    },

    /**
     *
     * @param key
     * @returns {string}
     */
    getClassName: function (key) {
        let website = config.website;
        return website + '-' + key;
    },

    /**
     *
     * @param key
     * @returns {string}
     */
    getStyleName: function (key) {
        //let website = config.website;
        let website = this.getWebSiteName();
        return website + '-' + key;
    },

    setfontSizePrice(num) {
        let website = this.getWebSiteName();
        let small = `${website}-price-small`;
        let middle = `${website}-price-middle`;
        let big = `${website}-price-big`;
        let biger = `${website}-price-biger`;
        let str = '' + num;
        let len = str.length;
        if (len <= 5) return '';
        if (len === 6) return biger;
        if (len === 7) return big;
        if (len === 8) return middle;
        if (len >= 9) return small;
    },

    setfontSizeGift(num) {
        let website = this.getWebSiteName();
        let small = `${website}-gift-smal`;
        let middle = `${website}-gift-middle`;
        let big = `${website}-gift-big`;
        let str = '' + num;
        let len = str.length;
        if (len <= 5) return '';
        if (len === 6) return big;
        if (len === 7) return middle;
        if (len >= 8) return small;
    },

    setfontSizePoint(num) {
        let website = this.getWebSiteName();
        let small = `${website}-point-small`;
        let middle = `${website}-point-middle`;
        let big = `${website}-point-big`;
        let str = '' + num;
        let len = str.length;
        if (len <= 5) return '';
        if (len === 6) return big;
        if (len === 7) return middle;
        if (len >= 8) return small;
    },


    /**
     * 5位数语言key转2位key
     * @param lang
     * @returns {*}
     */
    getLang5to2Value(lang) {
        let res = null;
        for (let key in this.lang2) {
            if (lang === key) {
                res = this.lang2[key];
                break
            }
        }
        return res;
    },

    /**
     * 其他位数语言key转五位key
     * @param lang
     * @returns {*}
     */
    getLang2Value(lang) {
        let res = null;
        for (let key in this.lang2key) {
            if (lang === key) {
                res = this.lang2key[key];
                break
            }
        }
        return res;
    },

    /**
     * 其他位数语言五位key转五位key
     * @param lang
     * @returns {*}
     */
    getLang5To5key(lang){
        let res = null;
        for (let key in this.lang5To5key) {
            if (lang === key) {
                res = this.lang5To5key[key];
                break
            }
        }
        return res;
    },

    getParamers(key){
        let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        let r = window.location.search.substr(1).match(reg);  //匹配目标参数
        if (r != null) return unescape(r[2]);
        return ''; //返回参数值
    },

    parseURL(url) {
        let a = document.createElement('a');
        a.href = url;
        return {
            source: url,
            protocol: a.protocol.replace(':', ''),
            host: a.hostname,
            port: a.port,
            query: a.search,
            params: (function () {
                let ret = {},
                    seg = a.search.replace(/^\?/, '').split('&'),
                    len = seg.length, i = 0, s;
                for (; i < len; i++) {
                    if (!seg[i]) {
                        continue;
                    }
                    s = seg[i].split('=');
                    if(s[1]) {
                        ret[s[0]] = s[1];
                    }
                }
                return ret;
            })(),
            file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
            hash: a.hash.replace('#', ''),
            path: a.pathname.replace(/^([^\/])/, '/$1'),
            relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
            segments: a.pathname.replace(/^\//, '').split('/')
        };
    },

    /**
     * 获取模版信息
     * @param appconfig
     * @param callback
     */
    initTplandThemeHandle(appconfig, callback){
        let urlParams = this.parseURL(window.location.href).params;
        this.ajax({
            url : appconfig.getTemplateUrl,
            data : {
                merchant_id: urlParams.merchant_id,
                merchant_shop_code: urlParams['gid'],
                platform : urlParams.platform ? urlParams.platform : 'web'
            },
            success:function(res){
                if(res.code === 200){

                    //从地址拦参数获取风格和模版信息
                    if(lodash.size(res.result) === 0){
                        res.result = {
                            theme : 't1',
                            tpl: 't1'
                        };
                        if(urlParams.theme){
                            res.result.theme =  urlParams.theme
                        }
                        if (urlParams.tpl) {
                            res.result.tpl = urlParams.tpl
                        }
                    }

                    //找不到风格使用默认风格
                    if(appconfig.THEME[res.result.theme]){
                        appconfig.PARAMS.theme = res.result.theme;
                    }

                    //找不到模版使用默认模版
                    if (appconfig.TPL[res.result.tpl]) {
                        appconfig.PARAMS.tpl = res.result.tpl;
                    }
                    callback(res);
                }
            },
            error:function(res){
                console.log('PARAMS(no)=>', appconfig.PARAMS);
                callback({
                    code : 1000,
                    message : 'error',
                    result : {
                        tpl: "t1",
                        theme : 't1'
                    }
                });
            }
        });
    },

    initConfigInfo(appconfig){

        let __defineParams = {};
        let urlParams = this.parseURL(window.location.href).params;
        __defineParams['user_id'] = urlParams.uid;
        __defineParams['merchant_shop_code'] = urlParams['gid'];
        __defineParams['merchant_id'] = urlParams.merchant_id;
        __defineParams['ad_source'] = urlParams.ad_source;
        appconfig.version = this.version;

        if (urlParams['server_sid']) {
            __defineParams.server_id = urlParams['server_sid'];
        }

        //其他位数语言key转五位语言key
        if (urlParams.lang && urlParams.lang.length !== 5) {
            urlParams.lang = urlParams.lang.toLowerCase(); //统一转小写
            let res = this.getLang2Value(urlParams.lang);
            if (res) urlParams.lang = res;
        }

        console.log(urlParams.lang);

        //找不到语言包使用默认语言
        if(urlParams.lang) {
            urlParams.lang = this.getLang5To5key(urlParams.lang.toLowerCase()); //统一转小写
            console.log('5=>', urlParams.lang);
            if(Language[urlParams.lang]){
                __defineParams.lang = urlParams.lang;
            }
        }

        //无平台信息使用默认平台
        if(urlParams.platform){
            __defineParams['platform'] = urlParams.platform;
        }

        //设置head信息Y显示，N显示
        if(urlParams.head === 'N'){
            __defineParams['head'] = 'N';
        }

        appconfig['PARAMS'] = lodash.extend({}, appconfig.PARAMS,__defineParams);
        console.log('params.lang=>', appconfig.PARAMS.lang);
        console.log('appconfig.PARAMS=>',appconfig['PARAMS']);
    },


    /**
     * 判断JS文件是否加载完成
     * @param url
     * @param callback
     */
    loadJS(url,callback){
        let ele = document.createElement('script');
        ele.type = "text/javascript";
        if (typeof(callback) != "undefined") {
            if (ele.readyState) {
                ele.onreadystatechange = function () {
                    if (ele.readyState === "loaded" || ele.readyState === "complete") {
                        ele.onreadystatechange = null;
                        callback();
                    }
                }
            } else {
                ele.onload = function () {
                    callback();
                }
            }
        }

        ele.src = url;
        document.body.appendChild(ele);
    },

    /**
     * 样式是否加载完毕
     * @param url
     * @param callback
     */
    loadCSS(url, callback){
        var ele = document.createElement('link');
        ele.type = "text/css";
        ele.rel = "stylesheet";
        ele.href = url;
        document.head.appendChild(ele);

        function getDemoPackageTop() {
            let demo_package = document.getElementById("demo_package");
            let top = '';
            if (demo_package['currentStyle']) {
                top = demo_package.currentStyle['top'];
            } else {
                top = getComputedStyle(demo_package, null)['top'];
            }

            console.log('demo_package-top=>', top);
            if (top === '0px') {
                console.log('AJAX_CSS_INIT_DONE=>', top);
                callback();
            } else {
                setTimeout(function () {
                    console.log('CSS_LOADING...');
                    getDemoPackageTop();
                }, 100);
            }
        }

        getDemoPackageTop();
    },

    /**
     * $.ajax封装
     * @param options
     */
    ajax(options) {
        var definOpt = {
            url: null,
            type: 'get',
            dataType: 'json',
            data: {},
            success: null,
            error: null,
            timeout: 120000,
            cache: false,
            cross: false
        };

        // 合并参数
        var opt = $.extend({}, definOpt, options);

        // 设置请求方式
        opt.type = opt.type === 'get' ? 'GET' : 'POST';

        // 判断是否为同域
        if (opt.cross) {
            let host = location.protocol + '//' + location.hostname;
            let crossdomain = opt.url.substr(0, host.length) != host;
            if (crossdomain) {
                if (opt.data.jsonpCallback) opt.jsonpCallback = opt.data.jsonpCallback;
                opt.type = 'GET';
                opt.dataType = "jsonp";
                opt.jsonp = "callback";
            }
        }

        if (opt.type === 'POST') {
            if (opt.url.indexOf('?') !== -1) {
                opt.url = opt.url + '&nocache=' + new Date().getTime();
            } else {
                opt.url = opt.url + '?nocache=' + new Date().getTime();
            }
        }


        $.ajax(opt);
    },

    /**
     * 页面跳转处理
     * @param $appConfig
     * @param error_code
     */
    repaymentJumpTo($appConfig,error_code){
        let PARAMS = $appConfig.PARAMS;
        let repaymentUrl = $appConfig.repaymentUrl.replace('@sid@', PARAMS.server_id);
        repaymentUrl = repaymentUrl.replace('@uid@', PARAMS.user_id);
        repaymentUrl = repaymentUrl.replace('@gamecode@', PARAMS.merchant_shop_code);
        repaymentUrl = repaymentUrl.replace('@platform@', 'web');
        repaymentUrl = repaymentUrl.replace('@merchant_id@', PARAMS.merchant_id);

        let unRepaymentTipUrl = $appConfig.unRepaymentTipUrl.replace('@sid@', PARAMS.server_id);
        unRepaymentTipUrl = unRepaymentTipUrl.replace('@uid@', PARAMS.user_id);
        unRepaymentTipUrl = unRepaymentTipUrl.replace('@gamecode@', PARAMS.merchant_shop_code);
        unRepaymentTipUrl = unRepaymentTipUrl.replace('@platform@', 'web');
        unRepaymentTipUrl = unRepaymentTipUrl.replace('@merchant_id@', PARAMS.merchant_id);

        //跳转到还款的页面
        if (error_code === 'pay_reversal') {
            console.log('pay_reversal=》跳转到还款的页面');
            window.location.href = repaymentUrl;
            return true;
        }

        //跳转到不可访问支付页面的提示页面
        if (error_code === 'forbidden_access_page') {
            console.log('forbidden_access_page=》跳转到不可访问支付页面的提示页面');
            window.location.href = unRepaymentTipUrl;
            return true;
        }

        //跳转到不可还款的页面
        if (error_code === 'pay_not_reversal') {
            console.log('pay_not_reversal=》跳转到不可还款的页面');
            window.location.href = unRepaymentTipUrl;
            return true;
        }

        //没有跳转地址
        console.log('repaymentJumpTo=>', error_code)
        return false;
    }

};



// WEBPACK FOOTER //
// ./website/common/common.js